import { AuthFlow } from "@/components/auth-flow"
import { AuthLayout } from "@/components/auth-layout"
import { PrivacyDisclaimer } from "@/components/privacy-disclaimer"
import { Box } from "@/designSystem/components/box"
import { FikaLogo } from "@/designSystem/components/fika-logo"
import { Text } from "@/designSystem/components/text"
import { useI18nContext } from "@/i18n/i18n-solid"
import { authContainer } from "./auth.css"

export function Auth(props: { isSuspended?: boolean }) {
  const { LL } = useI18nContext()

  return (
    <AuthLayout>
      <Box class={authContainer} alignItems="center">
        <Box flexDirection="column" gap="8" alignItems="center">
          <FikaLogo withText />
          <Text fontSize="h3" fontWeight="500" color="sand900">
            {LL().auth.signInOrSignUp()}
          </Text>
        </Box>

        <Text>{LL().auth.registrationsClosed()}</Text>

        <AuthFlow signupSource="writer" isSuspended={props.isSuspended} />

        <PrivacyDisclaimer />
      </Box>
    </AuthLayout>
  )
}
